import { Checkbox, ClickAwayListener, FormControl, Grow, IconButton, InputLabel, List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, ListSubheader, makeStyles, MenuItem, MenuList, Paper, Popper, TextField } from '@material-ui/core';
import { ArrowDropDown, Close, Search } from '@material-ui/icons';
import _ from 'lodash';
import { useSnackbar } from 'notistack';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { BootstrapInput } from 'react-components/BootstrapInput';
import { _T } from '../../../include/appI18n';
const useStyles = makeStyles((theme) => ({
    selectList: {
        overflow: 'auto',
        borderRadius: 4,
        background: theme.palette.background.paper,
        border: '1px solid #ced4da',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        cursor: 'pointer',
        '&:focus, &:hover': {
            backgroundColor: theme.palette.background.paper,
            borderColor: theme.palette.primary.main,
            transition: 0,
        },
        '& .MuiListSubheader-root': {
            background: theme.palette.secondary.main,
            color: theme.palette.common.white,
            marginTop: '-4px',
            padding: '4px 16px',
        },
    },
    selectListError: {
        borderColor: theme.palette.error.main,
    },
    selectListDisabled: {
        backgroundColor: theme.palette.grey[300],
    },
    multilineSubheader: {
        '& .MuiInput-underline:before, & .MuiInput-underline:hover:not(.Mui-disabled):before': {
            borderColor: '#fff',
        },
        '& .MuiInputBase-input': {
            color: '#fff',
        },
    },
}));
function MultiLineSelectList(props) {
    var _a;
    const classes = useStyles();
    const snackbar = useSnackbar();
    const [selected, setSelected] = useState(props.selected);
    const [searchText, setSearchText] = useState();
    const [searchOpen, setSearchOpen] = useState(false);
    const getOptionValue = (o) => typeof props.valueSelector == 'function' ? props.valueSelector(o) : o[props.valueSelector];
    const getOptionText = (o) => typeof props.textSelector == 'function' ? props.textSelector(o) : o[props.textSelector];
    const options = useMemo(() => searchText && searchOpen ? props.options.filter(o => getOptionText(o).toLowerCase().includes(searchText.toLowerCase())) : props.options, [props.options, searchOpen, searchText]);
    useEffect(() => {
        setSelected(selected.filter(s => props.options.findIndex(o => getOptionValue(o) == s) >= 0));
    }, [props.options, props.valueSelector]);
    useEffect(() => {
        if (props.onChange && !_.isEqual(_.orderBy(selected), _.orderBy(props.selected)))
            props.onChange(selected.filter(s => props.options.findIndex(o => getOptionValue(o) == s) >= 0));
    }, [selected]);
    const listClass = useMemo(() => `${classes.selectList}${props.error ? ` ${classes.selectListError}` : ''}${props.disabled ? ` ${classes.selectListDisabled}` : ''}`, [props.error, props.disabled]);
    return (React.createElement(FormControl, { fullWidth: true, variant: props.variant, className: "multiselect-wrapper", error: props.error, disabled: props.disabled },
        React.createElement(List, { className: listClass, style: { height: `${(_a = props.heightPx) !== null && _a !== void 0 ? _a : 300}px` }, subheader: !props.title ? undefined : React.createElement(React.Fragment, null, props.title || props.searchable ?
                React.createElement(ListSubheader, { className: classes.multilineSubheader }, !props.searchable || !searchOpen ? React.createElement(React.Fragment, null,
                    React.createElement(ListItemText, { primary: typeof props.title == "function" ? props.title(selected) : props.title }),
                    props.searchable || selected.length ?
                        React.createElement(ListItemSecondaryAction, null,
                            props.searchable ? React.createElement(IconButton, { disabled: props.disabled, onClick: () => setSearchOpen(true) },
                                React.createElement(Search, { htmlColor: "#fff" })) : null,
                            selected.length ? React.createElement(IconButton, { disabled: props.disabled, onClick: () => setSelected([]) },
                                React.createElement(Close, { htmlColor: "#fff" })) : null) : null) : React.createElement(React.Fragment, null,
                    React.createElement(ListItemText, { primary: React.createElement(TextField, { disabled: props.disabled, value: searchText, onChange: (e) => setSearchText(e.target.value), style: { color: '#fff', width: searchText ? 'calc(100% - 96px)' : 'calc(100% - 48px)' } }) }),
                    React.createElement(ListItemSecondaryAction, null,
                        React.createElement(IconButton, { disabled: props.disabled, onClick: () => setSearchOpen(false) },
                            React.createElement(Search, { htmlColor: "#fff" }))))) : null) }, options.map((o, i) => {
            let value = getOptionValue(o);
            let text = getOptionText(o);
            return (React.createElement("div", { key: i, onClick: () => {
                    if (props.disabled || (props.disableOption && props.disableOption(o)))
                        return;
                    const old = [...selected];
                    let newSelected = [];
                    if (selected.indexOf(value) > -1) {
                        newSelected = [...selected.filter(x => x != value && !!props.options.find(p => getOptionValue(p) == x))];
                    }
                    else {
                        newSelected = [...selected.filter(x => !!props.options.find(p => getOptionValue(p) == x)), value];
                    }
                    if (props.maxSelected && newSelected.length > props.maxSelected && props.maxSelectedAlertText) {
                        snackbar.enqueueSnackbar(props.maxSelectedAlertText, { variant: 'warning', autoHideDuration: 5000 });
                    }
                    else
                        setSelected(newSelected);
                } },
                React.createElement(ListItem, { dense: true, button: true, disabled: props.disabled || (props.disableOption && props.disableOption(o)) },
                    React.createElement(ListItemIcon, null,
                        React.createElement(Checkbox, { edge: "start", checked: selected.indexOf(value) > -1, tabIndex: -1, disableRipple: true })),
                    React.createElement(ListItemText, { primary: text }),
                    props.endAdornment ? React.createElement(ListItemSecondaryAction, null, props.endAdornment(o)) : null)));
        }))));
}
;
function DropdownSelectList(props) {
    var _a;
    const snackbar = useSnackbar();
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);
    //const anchorRef = React.useRef<HTMLButtonElement>(null);
    const getOptionValue = (o) => typeof props.valueSelector == 'function' ? props.valueSelector(o) : o[props.valueSelector];
    const getOptionText = (o) => typeof props.textSelector == 'function' ? props.textSelector(o) : o[props.textSelector];
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };
    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };
    const handleListKeyDown = (event) => {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        }
    };
    const [selected, setSelected] = useState(props.selected);
    const options = useMemo(() => props.options, [props.options]);
    useEffect(() => {
        if (props.onChange && !open && !_.isEqual(_.orderBy(selected), _.orderBy(props.selected)))
            props.onChange(_.orderBy(selected.filter(s => props.options.findIndex(o => getOptionValue(o) == s) >= 0)));
    }, [open]);
    useEffect(() => {
        const newSelected = selected.filter(s => props.options.findIndex(o => getOptionValue(o) == s) >= 0);
        setSelected(newSelected);
        if (props.onChange && !open && !_.isEqual(_.orderBy(newSelected), _.orderBy(props.selected)))
            props.onChange(_.orderBy(newSelected));
    }, [props.options, props.valueSelector]);
    const onAllChange = (e) => {
        if (e.target.checked && selected.length != options.filter(o => !props.disableOption || !props.disableOption(o)).length)
            setSelected(options.filter(o => !props.disableOption || !props.disableOption(o)).map(getOptionValue));
        else
            setSelected([]);
    };
    const onAllClick = (e) => {
        if (selected.length < options.filter(o => !props.disableOption || !props.disableOption(o)).length)
            setSelected(options.filter(o => !props.disableOption || !props.disableOption(o)).map(getOptionValue));
        else
            setSelected([]);
    };
    const valueLabel = useMemo(() => selected.length == 0 || selected.length == options.length ? '' : _.orderBy(selected.filter(o => !!o), undefined).map(o => {
        let f = options.find(p => getOptionValue(p) == o);
        return props.textSelector && f ? typeof props.textSelector == 'function' ? props.textSelector(f) : f[props.textSelector] : f;
    }).filter(o => o).join(', '), [selected, options, props.textSelector, props.valueSelector]);
    const prevOpen = useRef(open);
    // return focus to the button when we transitioned from !open -> open
    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [open]);
    return (React.createElement("div", { style: { display: 'flex' }, ref: anchorRef },
        React.createElement(FormControl, { fullWidth: true, variant: props.variant, error: props.error, disabled: props.disabled },
            React.createElement(InputLabel, { variant: props.variant, classes: {
                    shrink: props.noShrinkLabel ? 'no-shrink' : undefined,
                }, error: props.error }, typeof props.title == "function" ? props.title(selected) : props.title),
            React.createElement(BootstrapInput, { value: props.valueLabel ? props.valueLabel(selected) : valueLabel, onInput: (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                }, style: { caretColor: 'transparent' }, "aria-controls": open ? 'menu-list-grow' : undefined, "aria-haspopup": "true", onClick: handleToggle, endAdornment: React.createElement(ArrowDropDown, null), error: props.error })),
        React.createElement(Popper, { open: open, anchorEl: anchorRef.current, role: undefined, transition: true, disablePortal: true, style: { zIndex: 9999, width: 'fit-content', minWidth: (_a = anchorRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth } }, ({ TransitionProps, placement }) => {
            var _a;
            return (React.createElement(Grow, Object.assign({}, TransitionProps, { style: { transformOrigin: placement === 'bottom' ? 'left top' : 'left bottom', marginTop: placement === 'bottom' ? '2px' : 0, marginBottom: placement !== 'bottom' ? '2px' : 0 } }),
                React.createElement(Paper, { elevation: 4 },
                    React.createElement(ClickAwayListener, { onClickAway: handleClose },
                        React.createElement(MenuList, { autoFocusItem: open, id: "menu-list-grow", onKeyDown: handleListKeyDown, style: { maxHeight: (_a = props.heightPx) !== null && _a !== void 0 ? _a : 300, overflowY: 'auto' } },
                            !props.maxSelected ?
                                React.createElement(MenuItem, { dense: true, button: true, onClick: onAllClick },
                                    React.createElement(ListItemIcon, null,
                                        React.createElement(Checkbox, { edge: "start", checked: selected.length == options.filter(o => !props.disableOption || !props.disableOption(o)).length, tabIndex: -1, onChange: onAllChange, disableRipple: true })),
                                    React.createElement(ListItemText, { primary: _T.COMMON_ALL })) : null,
                            options.map((o, i) => {
                                let value = getOptionValue(o);
                                let text = getOptionText(o);
                                return (React.createElement(MenuItem, { dense: true, button: true, key: i, disabled: props.disabled || (props.disableOption && props.disableOption(o)), onClick: (e) => {
                                        if (props.disabled || (props.disableOption && props.disableOption(o)))
                                            return;
                                        let newSelected = [];
                                        if (selected.indexOf(value) > -1) {
                                            newSelected = [...selected.filter(x => x != value && !!props.options.find(p => getOptionValue(p) == x))];
                                        }
                                        else {
                                            newSelected = [...selected.filter(x => !!props.options.find(p => getOptionValue(p) == x)), value];
                                        }
                                        if (props.maxSelected && newSelected.length > props.maxSelected && props.maxSelectedAlertText) {
                                            snackbar.enqueueSnackbar(props.maxSelectedAlertText, { variant: 'warning', autoHideDuration: 5000 });
                                        }
                                        else
                                            setSelected(newSelected);
                                        e.stopPropagation();
                                    } },
                                    React.createElement(ListItemIcon, null,
                                        React.createElement(Checkbox, { edge: "start", checked: selected.indexOf(value) > -1, tabIndex: -1, disableRipple: true })),
                                    React.createElement(ListItemText, { primary: text }),
                                    props.endAdornment ? React.createElement(ListItemSecondaryAction, null, props.endAdornment(o)) : null));
                            }))))));
        })));
}
export default function MultiSelectList(props) {
    return React.createElement(React.Fragment, null, 'multiline' in props ? React.createElement(MultiLineSelectList, Object.assign({}, props)) : React.createElement(DropdownSelectList, Object.assign({}, props)));
}
